module.exports = __webpack_public_path__ + "static/media/pf.2a344488.svg";